import { action } from 'typesafe-actions';

import { EventList } from 'client/ducks/events-page/service';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { YearsFilter } from '@interfaces/years-filter';

import * as types from './types';

export const fetchEvents = (params: OutreachRequestParams = {}) => action(types.FETCH_EVENTS_PAGE, params);
export const fetchEventsSuccess = (data: EventList, params: OutreachRequestParams) =>
    action(types.FETCH_EVENTS_PAGE_SUCCESS, { data, params });
export const fetchEventsError = (error: Error) => action(types.FETCH_EVENTS_PAGE_ERROR, error);

export const fetchEventsFilters = () => action(types.FETCH_EVENTS_FILTERS);
export const fetchEventsFiltersSuccess = (data: YearsFilter) => action(types.FETCH_EVENTS_FILTERS_SUCCESS, data);
export const fetchEventsFiltersError = (error: Error) => action(types.FETCH_EVENTS_FILTERS_ERROR, error);
